import { LitElement, css, html } from 'lit';
import { customElement, property } from 'lit/decorators';

@customElement('form-tooltip')
export class FormTooltip extends LitElement {
    @property({ type: String })
    message?: string;

    @property({ type: String })
    tipwidth: string = '220px';

    @property({ type: String })
    leftPadding: string = '50%';

    @property({ type: String })
    position: string = 'bottom';

    @property({ type: Boolean })
    opened?: boolean;

    protected render() {
        const containerStyles = `width: ${this.tipwidth}; left: ${this.leftPadding}`;

        return html`
            <div class=${`tooltip ${this.position}`}>
                <slot></slot>
                <span class="tooltipText" style=${containerStyles}>${this.message}</span>
            </div>
        `;
    }

    static get styles() {
        return css`
            :host {
                --mdc-icon-size: 1rem;
            }

            .tooltip {
                position: relative;
                display: flex;
                cursor: pointer;
            }

            /* Tooltip text */
            .tooltip .tooltipText {
                visibility: hidden;
                background-color: var(--theme-white-color);
                color: var(--theme-input-color);
                text-align: center;
                padding: 0.75rem 1rem;
                border-radius: 0.75rem;
                border: 1px solid var(--theme-border-color);

                /* Position the tooltip text */
                position: absolute;
                z-index: 1;
                transform: translateX(-50%);

                /* Fade in tooltip */
                opacity: 0;
                transition: opacity 0.3s;
                box-shadow: 0px 80px 80px -20px rgba(154, 156, 165, 0.08),
                    0px 30px 24px -10px rgba(154, 156, 165, 0.05),
                    0px 12px 10px -6px rgba(154, 156, 165, 0.04),
                    0px 4px 4px -4px rgba(30, 33, 44, 0.03);
            }

            .tooltip.top .tooltipText {
                bottom: calc(100% + 0.5rem);
            }

            .tooltip.bottom .tooltipText {
                top: calc(100% + 0.5rem);
            }

            /* Tooltip arrow */
            .tooltip .tooltipText::after {
                position: absolute;
                left: 50%;
                margin-left: -5px;
                border-width: 5px;
                border-style: solid;
            }

            .tooltip.top .tooltipText::after {
                bottom: -10px;
                border-color: var(--theme-white-color) transparent transparent;
            }

            .tooltip.bottom .tooltipText::after {
                top: -10px;
                border-color: transparent transparent var(--theme-white-color);
            }

            .tooltip .tooltipText::before {
                position: absolute;
                left: 50%;
                margin-left: -6px;
                border-width: 6px;
                border-style: solid;
            }

            .tooltip.top .tooltipText::before {
                bottom: -12px;
                border-color: var(--theme-white-color) transparent transparent;
            }

            .tooltip.bottom .tooltipText::before {
                top: -12px;
                border-color: transparent transparent var(--theme-border-color);
            }

            /* Show the tooltip text when you mouse over the tooltip container */
            .tooltip:hover .tooltipText {
                visibility: visible;
                opacity: 1;
            }
        `;
    }
}
